import { render, staticRenderFns } from "./PcPcmTapKdTable1.vue?vue&type=template&id=92f7bcd2&"
import script from "./PcPcmTapKdTable1.vue?vue&type=script&lang=js&"
export * from "./PcPcmTapKdTable1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports